<template>
  <div>
    <div v-if="application.extraCash" class="position-relative mt-4">
      <div class="badge badge-success card-status px-2 py-1 position-absolute">
        {{ $t('LoanApplicationCard.extraCash') }}
      </div>
    </div>
    <div id="card-loan-application" class="card card-shadow border-0 card-rounded mb-3">
      <div class="card-body">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div class="card-title mb-0">{{ $t('LoanApplicationCard.yourApplication') }}</div>
          <router-link id="loan-application-details"
              :to="{ name: 'loan-application', params: { id: application.applicationId || application.reference }}"
              class="btn btn-link d-flex align-items-center mr-n3 button-loan-details">
            <Icon icon-name="info-outline"></Icon>
          </router-link>
        </div>
        <LoanApplicationTimeline :application="application"></LoanApplicationTimeline>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@shared/components/Icon'
import LoanApplicationTimeline from '@shared/components/LoanApplicationTimeline'

export default {
  name: 'LoanApplicationCard',
  components: { LoanApplicationTimeline, Icon },
  props: ['application']
}
</script>

<style scoped>

</style>
